var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.iconClass,attrs:{"src":_vm.iconPath,"width":"20px","height":"22px","alt":_vm.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }